import LangEnum from '../../../lang/LangEnum';
import { OrderBookBadgeValueType } from '../enums/orderBadgeDisplayType.enum';

export const getOrderBadgeValueTypeLangEnum = (type: OrderBookBadgeValueType): LangEnum => {
  switch (type) {
    case OrderBookBadgeValueType.ORDER_PRODUCTS:
      return LangEnum.GENERAL_SETTINGS_ORDER_BADGE_VALUE_TYPE_ORDER_PRODUCTS;
    case OrderBookBadgeValueType.PIECES:
      return LangEnum.GENERAL_SETTINGS_ORDER_BADGE_VALUE_TYPE_PIECES;
  }
};
